define(['jquery',
        'core/urls',
        'core/browser-storage',
        'clipboard-polyfill',
        'components/dropdown',
        'components/modal',
        'jquery.browser',
        '@claviska/jquery-minicolors'
    ],
    function ($, urls, browser_storage, clipboard_polyfill, DD, modal,) {

        var nodes = {
            configWrapper: document.querySelector(".config-options-wrap"),
            widgetOptions: document.querySelectorAll(".widget-options .option"),
            fullScreen: document.querySelector(".full-screen-icon"),
            fullScreenLabel: document.querySelector(".full-screen-icon .label"),
            previewPanel: document.querySelector(".preview-panel"),
            previewPanelHeader: document.querySelector(".preview-panel h2"),
            previewIframeContainer: document.querySelector(".preview-wrapper"),
            previewBreakpointOptions: document.querySelectorAll(".breakpoint-options .selection"),
            scrollTypeRadio: document.querySelector("#scrollType"),
            scrollTypeDescriptionStatic: document.querySelector(".scroll-static"),
            scrollTypeDescriptionDynamic: document.querySelector(".scroll-dynamic"),
            colorsWrap: document.querySelector(".style-options .colors-wrap"),
            nextButton: document.querySelector(".widget-next_js"),
            modals: {
                modal: document.querySelector(".modal_js"),
                close: document.querySelector(".modal-close_js"),
                content: document.querySelector(".modal-content_js"),
                title: document.querySelector(".modal-title_js"),
                bg: document.querySelector(".modal-bg_js"),
                blur: [
                    document.querySelector(".widget-configuration"),
                    document.querySelector(".sidebar-nav"),
                    document.querySelector(".navigation-top")
                ]
            },
        }

        var createdModal = modal.create(nodes.modals, function () {});

        var scoreType = nodes.scoreTypeOptions ? nodes.scoreTypeOptions.querySelector("input:checked").value : "CSAT";
        var widgetType = "scoreWidget"

        var csatSnippet = {
            timer: undefined,

            storeValues: function (values) {
                if (window.Sentry) {
                    Sentry.addBreadcrumb({ // production debugging statement: this should show up in Sentry!
                        message: 'Persisting new page state',
                        category: 'state',
                        data: values
                    });
                }
                browser_storage.setItem('csat-widget-options', JSON.stringify(values));
            },

            loadValues: function () {
                var options = browser_storage.getItem('csat-widget-options');
                try {
                    var options = JSON.parse(options);
                    if (options === undefined || options == null) {
                        return [];
                    }
                    return options;
                } catch (e) {
                    return [];
                }
            },

            currentOptions: function () {
                var values = $('[data-widgetoption-identifier]').map(function (item) {
                    if ($(this).hasClass('widget-options')) {
                        if ($(this).hasClass('radio')) {
                            var value = $(this).find('input:checked').attr("id");
                        } else {
                            var value = $(this).find('.option.active').attr("id");
                        }
                        return {
                            'identifier': $(this).attr('data-widgetoption-identifier'),
                            'value': value
                        };
                    } else if ($(this).hasClass("mini-toggle")) {
                        // use widgetoption-value if present, otherwise save checkbox value
                        let input = $(this).find('input')
                        var value = "";
                        
                        if(input.is(":checked")) {
                           value = input.attr('data-widgetoption-value') || "true";
                        }

                        return {
                            'identifier': $(this).attr('data-widgetoption-identifier'),
                            'value': value
                        };
                    } else if ($(this).hasClass('custom-select')) {
                        var value = $(this).find('select')[0].value;
                        return {
                            'identifier': $(this).attr('data-widgetoption-identifier'),
                            'value': value
                        };
                    } else {
                        if (!$(this).hasClass("disabled")) {
                            return {
                                'identifier': $(this).attr('data-widgetoption-identifier'),
                                'value': $(this).val()
                            };
                        }
                    }
                });

                return values.get(); // turn this from a jQuery object into a basic array, see https://api.jquery.com/map/
            },

            updateSnippet: function () {
                var values = this.currentOptions();
                var snippet = window.snippetTemplate;

                function replaceAll(str, find, replace) {
                    return str.replace(new RegExp(find, 'g'), replace);
                }

                $.each(values, function (index, item) {
                    snippet = replaceAll(snippet, `\\[\\[${item.identifier }\\]\\]`, item.value)
                });

                var snippetEl = $('#js-csatwidget-snippet')
                snippetEl.val(this.minifySnippet(snippet));

                this.updatePreview();
            },

            minifySnippet: function (snippet) {
                return snippet.replace(/\n/g, '').replace(/\s\s+/g, ' ');
            },

            updatePreview: function () {

                if (this.timer !== undefined) {
                    clearTimeout(this.timer);
                }

                nodes.previewPanel.classList.add("loading");

                var snippetCode = $('#js-csatwidget-snippet').val();

                // add isPreview variable when loading widget into the preview mode - 
                // we use this to invalidate browser cache of data calls within the widget
                snippetCode = snippetCode.replace("var sbWidgetSettings = [];", "var sbWidgetSettings = []; var isPreview = true;");

                var breakpointPreview = document.querySelector(".breakpoint-options .active").getAttribute("data-breakpoint");
                var source = encodeURI(`
                    <html>
                        <head>
                            <meta name="viewport" content="width=device-width, initial-scale=1" />
                            <style>body {margin:0;padding:0;}.wrapper{text-align: center;}</style>
                        </head>
                        <body class="${breakpointPreview} preview-body">
                            <div class='wrapper'>
                                ${snippetCode}
                            </div>
                        </body>
                    </html>`);

                var content = "data:text/html;charset=utf-8," + source.replace(/#/g, '%23');
                var iframe = document.createElement('iframe');
                iframe.setAttribute('id', 'csat-widget-preview-iframe');
                iframe.src = content;

                $('#widget-style-preview').html(iframe);

                setTimeout(() => {
                    nodes.previewPanel.classList.remove("loading");
                }, 300)

                $timer = undefined;
            },
        };

        let addEventListeners = () => {
            // enable full screen preview button
            nodes.fullScreen.addEventListener("click", () => {
                nodes.previewPanel.classList.toggle("full");
                nodes.fullScreen.classList.toggle("open");
                
                const yOffset = -80; 
                const y = nodes.fullScreen.getBoundingClientRect().top + window.pageYOffset + yOffset;

                window.scrollTo({top: y});

                let label = nodes.fullScreen.classList.contains("open") ? "Exit" : "Full view"

                nodes.fullScreenLabel.innerText = label;
            })

            nodes.previewPanelHeader.addEventListener("touchstart", () => {
                window.scrollTo({ top: document.body.scrollHeight - 700, behavior: 'smooth' })
            })

            // enable preview window breakpoint views for widget (desktop / tablet / mobile)
            nodes.previewBreakpointOptions.forEach(option => {
                option.addEventListener("click", () => {
                    document.querySelector(".breakpoint-options .selection.active").classList.remove("active");
                    option.classList.add("active");
                    csatSnippet.updatePreview();

                    var breakpointPreview = document.querySelector(".breakpoint-options .active").getAttribute("data-breakpoint");
                    nodes.previewIframeContainer.setAttribute("data-breakpoint", breakpointPreview)
                })
            });

            nodes.nextButton.addEventListener("click", () => {
                let snippetModal = document.querySelector(".modal-template-snippet_js");
                createdModal.open({
                    class: "error-modal",
                    content: snippetModal.innerHTML,
                    title: ""
                }, function (el) {
                    el.querySelector(".button-primary").addEventListener("click", createdModal.close);
                    let originalSnippet = document.querySelector(".modal-template-snippet_js #js-csatwidget-snippet");
                    let modalSnippet = document.querySelector(".sb-modal__content textarea");
                    let copyButton = document.querySelector(".sb-modal #js-csatwidget-copysnippet")
                    modalSnippet.value = originalSnippet.value;
                    
                    copyButton.addEventListener("click", (e) => {
                        e.preventDefault();
                        navigator.clipboard.writeText(modalSnippet.value)
                        copyButton.innerText = "Copied!"

                        setTimeout(() => {
                            copyButton.innerText = "Copy snippet"
                        }, 4000)
                    })
                });
            })

            document.querySelector("#compactLayoutToggle").addEventListener("change", event => {
                if(event.target.checked) {
                    nodes.previewIframeContainer.setAttribute("data-layout", "compact");
                } else {
                    nodes.previewIframeContainer.setAttribute("data-layout", "standard");
                }
            })

            nodes.widgetOptions.forEach((option) => {
                option.addEventListener("click", () => {
                    document.querySelector(".widget-options .option.active").classList.remove('active');
                    widgetType = option.getAttribute("id");
                    option.classList.add("active");
                    nodes.configWrapper.dataset.widgetOption = widgetType;

                    if(widgetType === "scoreWidget") {
                        let checkedInput = document.querySelector(".score-options input:checked");
                        if(!checkedInput) {
                            // ensure scoreWidget has at least one score enabled
                            document.querySelector(".score-options input").checked = true;
                        }
                    }
                })
            })

            document.querySelectorAll("#scoreTypeOptions input").forEach(option => {
                option.addEventListener("click", (event) => {
                    handleReviewsWidgetState(event.target.getAttribute("id"));
                })
            })

            document.querySelectorAll(".score-options input").forEach(input => {
                input.addEventListener("change", () => {
                    if(widgetType !== "scoreWidget") return; // only applies to score widget
                    let checkedInput = document.querySelector(".score-options input:checked");
                    if(!checkedInput) {
                        input.checked = true;
                        let errorNode = document.querySelector(".score-options-error");
                        errorNode.classList.add("show")
                        
                        setTimeout(() => {
                            errorNode.classList.remove("show");
                        }, 3000)
                    }
                })
            });
        }

        return {
            init: function () {
                // initialize dropdowns
                document.querySelectorAll(".custom-select").forEach(el => {
                    DD(el, (value) => {
                        if(el.dataset.widgetoptionIdentifier === "widgetContent") {
                            if(value === "reviewsOnly") {
                                nodes.colorsWrap.classList.add("hide");
                            } else {
                                nodes.colorsWrap.classList.remove("hide");
                            }
                        }
                    });
                })

                // initialize colour picker
                $('.minicolors-input').minicolors($.minicolors.defaults);

                addEventListeners();

                // update widget values when changed
                $('.widget-option').on('change', function (event) {
                    var values = csatSnippet.currentOptions();
                    csatSnippet.storeValues(values);
                    csatSnippet.updateSnippet();
                }.bind(this));

                let backgroundCheckbox = document.querySelector("#useDefaultBackground");
                let handleDefaultBackground = () => {
                    let backgroundColor = $("#mainheader-background-color");
                    if (backgroundCheckbox.checked) {
                        backgroundColor.add(backgroundColor.parent()).addClass("disabled");
                    } else {
                        backgroundColor.add(backgroundColor.parent()).removeClass("disabled");
                    }
                    var values = csatSnippet.currentOptions();
                    csatSnippet.storeValues(values);
                    csatSnippet.updateSnippet();
                }

                backgroundCheckbox.addEventListener('change', handleDefaultBackground);

                backgroundCheckbox.checked = true;
                handleDefaultBackground();

                $('.custom-select .mock-options').add('.widget-options').on('click', (event) => {
                    setTimeout(function () {
                        scoreType = nodes.scoreTypeOptions ? nodes.scoreTypeOptions.querySelector("input:checked").value : scoreType;
                        var values = csatSnippet.currentOptions();
                        csatSnippet.storeValues(values);
                        csatSnippet.updateSnippet();
                    }, 1);
                });

                $('.reset-styles').on('click', function (event) {
                    $('#mainheader-background-color').minicolors('value', {
                        'color': '#FFFFFF'
                    });
                    $('#mainheader-text-color').minicolors('value', {
                        'color': '#9D3AFF'
                    });
                    $('#primary-text-color').minicolors('value', {
                        'color': '#00054D'
                    });
                    $('#secondary-text-color').minicolors('value', {
                        'color': '#6D6F94'
                    });

                    backgroundCheckbox.checked = true;
                    handleDefaultBackground();

                    document.querySelectorAll("#csat-widget-optiontype .mock-options div")[0].click();
                    document.querySelectorAll("#border-option .mock-options div")[0].click();
                    document.querySelectorAll("#dropshadow-option .mock-options div")[1].click();
                    document.querySelectorAll("#language-option .mock-options div")[0].click();
                    document.querySelectorAll("#content-option .mock-options div")[0].click();

                    var values = csatSnippet.currentOptions();
                    csatSnippet.storeValues(values);
                    csatSnippet.updateSnippet();

                    event.preventDefault();
                    return false;
                });

                var initialValues = csatSnippet.loadValues();
                $.each(initialValues, function (index, val) {
                    if (val.identifier === 'widgetContent') {
                        $('[data-widgetoption-identifier="' + val.identifier + '"]').find('[data-widgetoption-value]').removeClass('active');
                        $('[data-widgetoption-identifier="' + val.identifier + '"]').find('[data-widgetoption-value="' + val.value + '"]').addClass('active');
                    } else {
                        if (val.identifier === 'backgroundColor' ||
                            val.identifier === 'scoreColor' ||
                            val.identifier === 'textColor01') {
                            // add selected colors to colorpicker
                            $('[data-widgetoption-identifier="' + val.identifier + '"]').minicolors('value', {
                                'color': val.value
                            });
                        }

                    }
                });

                csatSnippet.updateSnippet();
            }
        }
    }
);